import Box from '@eversports/klimt-primitives/legacy/Box'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Svg from '@eversports/klimt-primitives/legacy/Svg/Svg'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { VenueProfileTabsPrefix } from '../../../App.types'
import { Localized, useIntl } from '../../../localization/react'
import { Venue } from '../ActivityDetails.types'
import ContentWrapper from '../components/ContentWrapper'

import ExternalLinkIcon from './assets/external-link.svg'
import Reviews from './Reviews'

interface Props {
  venue: Venue
}

const VenueInformation = ({ venue }: Props) => {
  const { name, slug, logo } = venue

  const intl = useIntl()

  return (
    <ContentWrapper>
      <Stack gap={4} sx={{ overflow: 'hidden' }}>
        <Heading is="h2" color="midnight">
          <Localized id="activity-details-venue-information-header" />
        </Heading>
        <Stack gap={6}>
          <Stack direction="row" gap={5}>
            <Link
              to={`${VenueProfileTabsPrefix.OVERVIEW}${slug}`}
              blank
              ariaLabel={intl.activityDetailsVenueProfileLinkAriaLabel({ venueName: venue.name })}
            >
              <Stack direction="row" alignItems="center" gap={2}>
                <Box sx={{ border: '1px solid', borderColor: 'mediumgray', borderRadius: 1, overflow: 'hidden' }}>
                  <img
                    src={logo?.xSmall}
                    width={40}
                    height={40}
                    loading="lazy"
                    alt={intl.venueLogoAltText()}
                    style={{ objectFit: 'contain' }}
                  />
                </Box>
                <Text
                  color="midnight"
                  sx={{ fontWeight: 'bold', textDecoration: 'underline', '&:hover': { cursor: 'pointer' } }}
                >
                  {name}
                </Text>
                <Box sx={{ marginTop: 1 }}>
                  <Svg src={ExternalLinkIcon} width={12} height={12} />
                </Box>
              </Stack>
            </Link>
          </Stack>
          <Reviews venue={venue} />
        </Stack>
      </Stack>
    </ContentWrapper>
  )
}
export default VenueInformation
